import React from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import { Link } from 'react-router-dom'
import Aux from 'hoc/Auxiliary'
import Meta from 'components/Meta'

export const View = () => {
	return <Aux>
		<Meta page='error' />
		<Header title='Страницата не е намерена'/>
		<div className='c-content'>
			<div className='o-wrapper u-padding-vertical-large'>
				<div className='u-bg--white u-padding-horizontal u-padding-vertical-large u-border-radius u-box-shadow'>
					<div className='o-layout o-layout--center'>
						<div className='o-layout__item u-1/1 u-1/2@tablet u-margin-bottom'>
							<img src='/img/calculator.gif' alt='404 page' />
						</div>
						<div className='o-layout__item u-1/1'>
							<Link className='o-block' to='/'><span className='c-btn c-btn--cornflower'>Върни ме в началото</span></Link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer selectedMode='monetary' />
	</Aux>
}

export default View
